import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SubmitButton from "../../common/button/SubmitButtton";
import useShowAlert from "../../../utiles/AlertUtiles";
import { removeWhitespace } from "../../../utiles/helpers";
import useErrorHandle from "../../../constant/errorHandling/useErrorHandle";
import { setData } from "../../../utiles/CookieUtile";
import SuccessMsg from "../../../constant/messages/SuccessMessage";
import checkNetworkStatus from "../../common/networkStatus/CheckNetworkStatus";
import uRLs from "../../../utiles/BaseUtile";
import axios from "axios";
import { authToken } from "../../../services/authService";

const Login = ({ setLoggedIn }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const handleError = useErrorHandle();
  const [error, setError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const Logo = process.env.REACT_APP_LOGO_URL;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const showAlert = useShowAlert();
  console.log("env name", uRLs.ENV_NAME);
  const handleLoginSubmit = (e) => {
    e.preventDefault();
    setError("");
    setPasswordError("");

    if (!email) {
      setError("Email is required");
    } else if (!emailRegex.test(email)) {
      setError("Please enter a valid email address");
    } else if (!password) {
      setPasswordError("Password cannot be empty.");
    } else if (password.length < 6) {
      setPasswordError("Password must be at least 6 characters.");
    } else {
      loginHandler();
    }
  };

  const loginHandler = async () => {
    checkNetworkStatus();
    setLoading(true);

    try {
      const result = await axios.post(
        `${uRLs.SALE_BASE_URL}auth-login`,
        {
          username: email,
          password: password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (result) {
        showAlert("success", SuccessMsg.LOGIN_SUCCESS);
        setData("accessToken", result.data.results.accessToken);
        setData("refreshToken", result.data.results.refreshToken);
        setLoggedIn(true);
        navigate("/dashboard");
        await authToken(navigate, setLoggedIn, handleError);
      }
    } catch (error) {
      const code = error?.response?.data?.code;
      const message =
        error?.response?.data?.message || "Login failed. Please try again.";
      if (code === "INVALID_USERNAME") {
        setError(message);
      } else if (code === "INVALID_PASSWORD") {
        setPasswordError(message);
      } else {
        handleError(error);
      }

      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="wrapper">
        <div className="section-authentication-cover">
          <div className="">
            <div className="row g-0">
              <div className="col-12 col-xl-7 col-xxl-8 auth-cover-left align-items-center justify-content-center d-none d-xl-flex">
                <div className="card shadow-none bg-transparent shadow-none rounded-0 mb-0">
                  <div className="card-body">
                    <img
                      src="/assets/images/v1/login-image/bankImg.png"
                      className="img-fluid"
                      width="600"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 col-xl-5 col-xxl-4 auth-cover-right align-items-center justify-content-center">
                <div className="card rounded-0 m-3 shadow-none bg-transparent mb-0">
                  <div className="card-body p-sm-5">
                    <div className="p-3 text-center">
                      <div className="text-center">
                        <img src={Logo} width="60" alt="" />
                      </div>

                      <>
                        <h4 className="text-center mt-5 font-weight-bold">
                          Welcome to NegoBill Admin Panel
                        </h4>
                        <p className="text-center text-muted">
                          {/* By continuing with your registered email ID */}
                        </p>
                        <form onSubmit={handleLoginSubmit} className="row g-3">
                          <div className="col-12">
                            <label
                              htmlFor="email"
                              className="form-label  text-left"
                            >
                              Email<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="email"
                              autoComplete="off"
                              value={email}
                              onChange={(e) => {
                                setError("");
                                setEmail(
                                  removeWhitespace(
                                    e.target.value.trim().toLowerCase()
                                  )
                                );
                              }}
                            />
                            {error && (
                              <small className="text-danger pt-2  text-left">
                                {error}
                              </small>
                            )}
                          </div>
                          <div className="col-12">
                            <label
                              htmlFor="inputPassword"
                              className="form-label  text-left"
                            >
                              Password <span className="text-danger">*</span>
                            </label>
                            <div className="input-group">
                              <input
                                type={passwordVisible ? "text" : "password"}
                                className="form-control"
                                value={password}
                                onChange={(e) => {
                                  setPassword(removeWhitespace(e.target.value));
                                  setPasswordError("");
                                }}
                              />
                              <span
                                className="input-group-text"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  setPasswordVisible((prev) => !prev)
                                }
                              >
                                <i
                                  className={
                                    passwordVisible
                                      ? "bx bx-show"
                                      : "bx bx-hide"
                                  }
                                ></i>
                              </span>
                            </div>
                            {passwordError && (
                              <small className="text-danger pt-2 text-left">
                                {passwordError}
                              </small>
                            )}
                          </div>

                          {/* <div className="col-12 text-end">
                            <Link
                              to="/forgot-password"
                              className="text-primary"
                            >
                              Forgot password?
                            </Link>
                          </div> */}
                          <div className="col-12 d-grid mt-3">
                            <SubmitButton
                              label="Login "
                              onClick={handleLoginSubmit}
                              loading={loading}
                            />
                          </div>
                        </form>
                      </>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
